<nz-card nzTitle="Cost Details">
  <!-- ERROR STATE -->
  <ng-container *ngIf="hasError$ | async">
    <em-error-result subTitle="An error occurred loading equipment details."></em-error-result>
  </ng-container>

  <!-- NO DATA STATE -->
  <ng-container *ngIf="hasNoData$ | async">
    <p>No equipment data available.</p>
  </ng-container>

  <!-- LOADING + DATA STATE -->
  <ng-container *ngIf="hasData$ | async">
    <nz-skeleton nz-active [nzLoading]="(loading$ | async) ?? false">
      <ng-container *ngIf="equipment$ | async as equipment">
        <nz-descriptions nzTitle="Costs" nzLayout="vertical">
          <nz-descriptions-item nzTitle="Acquisition">
            <em-display-property [value]="equipment.aquisitionValue"></em-display-property>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Mould budget year">
            <em-display-property [value]="equipment.mouldBudgetYear"></em-display-property>
          </nz-descriptions-item>
        </nz-descriptions>
      </ng-container>
    </nz-skeleton>
  </ng-container>
</nz-card>
